import {
	ACCEPT_BUDGET_INVITE_BEGIN,
	ACCEPT_BUDGET_INVITE_FAIL,
	ACCEPT_BUDGET_INVITE_SUCCESS,
	BEGIN_SHARE_BUDGET_BY_EMAIL_BEGIN,
	BEGIN_SHARE_BUDGET_BY_EMAIL_FAIL,
	BEGIN_SHARE_BUDGET_BY_EMAIL_SUCCESS,
	CHANGE_ACTIVE_BUDGET_BEGIN,
	CHANGE_ACTIVE_BUDGET_FAIL,
	CHANGE_ACTIVE_BUDGET_SUCCESS,
	END_SHARE_BUDGET_SUCCESS,
	GET_SHARED_BUDGETS_SUCCESS, REJECT_BUDGET_INVITE_BEGIN, REJECT_BUDGET_INVITE_FAIL,
	REJECT_BUDGET_INVITE_SUCCESS
} from "../actions/sharing.js";


const defaultState = {
	submittingShareBudget: false,
	budgets: null,
	changingActiveBudgetId: null,
	acceptingInviteBudgetId: null,
	rejectingInviteBudgetId: null,
};

export default function(state = defaultState, action) {
	switch(action.type) {
		case ACCEPT_BUDGET_INVITE_BEGIN:
			return {
				...state,
				acceptingInviteBudgetId: action.payload,
			}
		case REJECT_BUDGET_INVITE_BEGIN:
			return {
				...state,
				rejectingInviteBudgetId: action.payload,
			}
		case REJECT_BUDGET_INVITE_FAIL:
			return {
				...state,
				rejectingInviteBudgetId: null,
			}
		case ACCEPT_BUDGET_INVITE_FAIL:
			return {
				...state,
				acceptingInviteBudgetId: null,
			}
		case CHANGE_ACTIVE_BUDGET_BEGIN: {
			return {
				...state,
				changingActiveBudgetId: action.payload,
			};
		}
		case CHANGE_ACTIVE_BUDGET_FAIL:
		case CHANGE_ACTIVE_BUDGET_SUCCESS: {
			return {
				...state,
				changingActiveBudgetId: null,
			};
		}
		case ACCEPT_BUDGET_INVITE_SUCCESS: {
			return {
				...state,
				budgets: action.payload,
				acceptingInviteBudgetId: null,
			};
		}
		case REJECT_BUDGET_INVITE_SUCCESS: {
			return {
				...state,
				budgets: action.payload,
				rejectingInviteBudgetId: null,
			};
		}
		case END_SHARE_BUDGET_SUCCESS:
		case GET_SHARED_BUDGETS_SUCCESS: {
			return {
				...state,
				budgets: action.payload,
			};
		}
		case BEGIN_SHARE_BUDGET_BY_EMAIL_FAIL: {

			return {
				...state,
				submittingShareBudget: false,
			};
		}
		case BEGIN_SHARE_BUDGET_BY_EMAIL_SUCCESS: {

			return {
				...state,
				submittingShareBudget: false,
				budgets: action.payload,
			};
		}
		case BEGIN_SHARE_BUDGET_BY_EMAIL_BEGIN: {

			return {
				...state,
				submittingShareBudget: true,
			};
		}


		default:
			return state;
	}
}